const browserGlobalThis = globalThis;

// es-toolkit's internal globalThis module is imported under two names across
// versions: `globalThis` (older) and `globalThis_` (>=1.47). The vite plugin
// (apps/web/vite.config.ts) redirects both to this CSP-safe shim, so export
// both aliases — otherwise the build fails with "globalThis_ is not exported".
export { browserGlobalThis as globalThis, browserGlobalThis as globalThis_ };
